import {
  DataTable,
  DataTableProps,
} from "../../../components/common/data-table/DataTable";
import Loading from "../../../components/Loading";
import { ColumnInterface } from "../../../interfaces/customTableInterface";
import { RoleInterface } from "../../../interfaces/roleInterface";

type RoleTableProps = {
  data: RoleInterface[];
  isLoading: boolean;
} & Pick<
  DataTableProps<RoleInterface>,
  "pagination" | "extraActions" | "sortBy" | "sortOrder" | "onSort"
>;

const columns: ColumnInterface<RoleInterface>[] = [
  { key: "name", label: "Nombre" },
  { key: "active", label: "Activo", isBoolean: true },
];

export const RoleTable = (props: RoleTableProps) => {
  const { isLoading, ...rest } = props;

  if (isLoading) return <Loading />;

  return (
    <DataTable
      columns={columns}
      tableId="roles-table"
      customRender={(key, item) => {
        if (key === "active") {
          return item.active ? "Activo" : "Inactivo";
        }
        return item[key] ?? "N/A";
      }}
      {...rest}
    />
  );
};
